/**
 * Created by rastwe on 1/16/2017.
 * @module $Name$
 * @extends React.Component
 */
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import {SVGICONS} from '@ey/icons';
import {labels} from '../../util/utils';
import {useIsDrawerMode} from '../../util/Ares/customHooks';
import TimeTrackerContainer from '../Common/TimeTracker/TimeTrackerContainer';
import {useUserPreferences} from '../../util/customHooks';
import _ from 'lodash';
import './index.scss';
import '@ey/motif-react-wrapper/ey-asu-motif.css';
import '@ey/styled-theme/styles.css';
import './main.less';

export default function Main(props) {
	const {children} = props;
	const apponlinestate = useSelector((store) => store.apponlinestate),
		configurations = useSelector((store) => store.configurations),
		connectivitystate = useSelector((store) => store.connectivitystate),
		offlinePrep = useSelector((store) => store.offlinePrep),
		syncState = useSelector((store) => store.syncState),
		appVersionState = useSelector((store) => store.appVersion),
		userPreferences = useUserPreferences(),
		isStandaloneView = useSelector((store) => store.isStandaloneView);

	const isDrawerMode = useIsDrawerMode();

	const [onlineState, setOnlineState] = useState(apponlinestate);

	useEffect(() => {
		if (apponlinestate !== onlineState) {
			window.location.reload();
		}
	}, [apponlinestate]);

	useEffect(() => {
		if (appVersionState.upgrade) {
			localStorage.setItem('app.version', appVersionState.version);
			window.location.reload();
		}
	}, [appVersionState]);

	const configFeatures = configurations && configurations?.features && configurations?.features;

	const isTrainingEnvironment = configFeatures?.isTrainingEnvironment === true;

	const enableTimeTracker = configFeatures?.enableTimeTracker === true;

	// Hide time tracker for FIT V2 drawer mode (isDrawer = true query string param)
	let showTimeTracker = !isDrawerMode && enableTimeTracker && !userPreferences.isGuestUser;

	const classes = apponlinestate
		? offlinePrep
			? _.isBoolean(syncState) && syncState
				? 'syncstate'
				: isTrainingEnvironment
				? 'training '
				: ''
			: 'offlineprep'
		: _.isBoolean(connectivitystate) && connectivitystate
		? 'connection-available'
		: 'offline';

	return (
		<section className={classes + ' ' + (isStandaloneView ? 'main mainPrint' : 'main') + ' key'}>
			{!apponlinestate ? (
				_.isBoolean(connectivitystate) && connectivitystate ? (
					<OfflineContainerwrapper className="connectionAvailable">
						<SVGICONS styleName="small" name="wifi" hoverText="" alt="connection available" />
						<span>{labels.connectionavilable}</span>
					</OfflineContainerwrapper>
				) : (
					<OfflineContainerwrapper className="workingOffline">
						<SVGICONS styleName="small" name="wifi-off" hoverText="" alt="offline" />
						<span>{labels.workingoffline}</span>
					</OfflineContainerwrapper>
				)
			) : !offlinePrep ? (
				<OfflineContainerwrapper className="prepareOffline">
					<span>{labels.prepareoffline}</span>
				</OfflineContainerwrapper>
			) : _.isBoolean(syncState) && syncState ? (
				<OfflineContainerwrapper className="syncInProgress">
					<span>{labels.syncinprogress}</span>
				</OfflineContainerwrapper>
			) : isTrainingEnvironment ? (
				<OfflineContainerwrapper className="training">
					<span>{labels.training}</span>
				</OfflineContainerwrapper>
			) : (
				''
			)}
			<MainContainerWrapper
				className={`MainContainerWrapper ${
					!window.location.pathname.toLowerCase().startsWith('/guidedworkflow') &&
					!window.location.pathname.toLowerCase().startsWith('/guidedworkflowv2') &&
					!window.location.pathname.toLowerCase().startsWith('/fit') &&
					!window.location.pathname.toLowerCase().startsWith('/standalone') &&
					!window.location.pathname.toLowerCase().startsWith('/drydock')
						? $(document).hasClass('leftSideSection')
							? ''
							: 'left-margin'
						: ''
				}`}
			>
				{children}
				{showTimeTracker && <TimeTrackerContainer />}
			</MainContainerWrapper>
		</section>
	);
}

const MainContainerWrapper = styled.section`
	display: flex;
	flex-direction: column;
	flex: 1 1 0;
	overflow-x: hidden;
	max-width: 2048px;
	&.left-margin {
		margin-left: var(--px-390);
	}
	&:has(.cookie-settings) {
		margin-left: 0;
	}
`;

const OfflineContainerwrapper = styled.section`
	box-shadow: 0 0 0 0 #21852e;
	position: absolute;
	font-weight: 700;
	vertical-align: middle;
	text-align: center;
	left: 45%;
	display: flex;
	height: auto;
	padding: var(--px-5);
	background: var(--neutrals-00white);
	z-index: 99;
	&.syncInProgress,
	&.connectionAvailable {
		background: var(--blue-300);
	}
	&.prepareOffline,
	&.workingOffline {
		background: var(--teal-500);
	}
	&.training {
		background: var(--purple-400);
		padding: 0;
	}

	span {
		text-align: center;
		margin: var(--px-3);
		padding: 0;
		font-weight: bold;
		width: auto;
		vertical-align: top;
		line-height: initial;
		color: var(--neutrals-00white);
		font-size: var(--px-12);
	}
	svg {
		fill: var(--neutrals-00white);
	}
`;
